module.exports = __webpack_public_path__ + "static/media/plus-red.de5fe431.svg";